export interface AdditionalClassificationVerification {
    mismatchedClassificationPaths: string[];
    verificationIncomplete: boolean;
    warnings: string[];
}

export const classificationMismatchMessage = 'Classification does not match the SICS database configuration.';
export const classificationVerificationIncompleteMessage =
    'Additional Classifications could not be verified against the target SICS database configuration. Check the Contracts Ingestion connection settings and retry verification.';
